export interface IAnalyticsOptions {}

export abstract class AnalyticsOptions implements IAnalyticsOptions {
  public values: any[];

  constructor(values: any[]) {
    this.values = values;
  }
}
